import React, { useState } from "react";
import { useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import CheckoutAddressGroup from "./AddressGroup";
import CircularProgress from "@mui/material/CircularProgress";
import AddOrEditAddress from "../../Shared/AddOrEditAddress";
import styled from "styled-components";
import CheckoutAddressGroupNew from "./AddressGroupNew";

const CheckoutAddressNew = (props) => {
  const { currentStep = {}, stepAction = () => {} } = props;
  // eslint-disable-next-line no-unused-vars
  const [isLoading, setIsLoading] = useState(false);
   const guestUser = useSelector((state) => state.userDetails?.isGuest);
  const [enableAddAddress, setEnableAddAddress] = useState(false);
  
  const { step = 0 } = currentStep;
  const userProfile = useSelector((state) => state.userDetails || {});

  const { isGuest = true } = userProfile;

  const disableAddAddress = () => {
    setEnableAddAddress(false);
  };

  const CheckoutAddressContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;

    
    width: 99%;
    margin-top: 0.5rem;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
  `;
  const CheckoutAddressEdit = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 16px;
    font-size: 0.8rem;
    font-family: Ancizar Sans;
  `;

  const AddressListContainer = styled.div`
  display:flex;
  flex-direction:row;

  `

    const addNewAddressClick = () => {
    setEnableAddAddress(true);
  };


  return (
    <CheckoutAddressContainer>
      {step === 2 &&
        (isLoading ? (
          <>
            <CircularProgress />
          </>
        ) : (
          <>
            <CheckoutAddressEdit onClick={() => stepAction(2)} >Edit Address</CheckoutAddressEdit>
            {isGuest ? (
             <></>
            ) : (
              <AddressListContainer>
                
                <CheckoutAddressGroupNew stepAction={stepAction} />
              </AddressListContainer>
              
            )}
          </>
        ))}
    </CheckoutAddressContainer>
  );
};

export default CheckoutAddressNew;
